export const APA_CALENDER_TABLE_REQUEST = 'APA_CALENDER_TABLE_REQUEST';
export const APA_CALENDER_TABLE_SUCCESS = 'APA_CALENDER_TABLE_SUCCESS';
export const APA_CALENDER_TABLE_FAIL    = 'APA_CALENDER_TABLE_FAIL';
